



















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, AddDriverRequest, Document, Address } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { LoaderEvent, ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { Driver, ServiceRequest, TransporterLoc } from '../../types/entity';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { DateUtils } from '@/util/dateUtils';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
declare var google: any;
const mmddyyyyFormat = (value: string) => {
  return /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19|20)\d\d$/.test(value);
};
const validBirthDate = (value: string): boolean => {
  const parsed = parseMMDDYYYY(value);
  if (!parsed) {
    return false;
  }
  const ageLimit = new Date();
  ageLimit.setFullYear(ageLimit.getFullYear() - 23);
  return parsed <= ageLimit;
};

const parseMMDDYYYY = (value: string): Date | null => {
  if (!value || value.length !== 10) {
    return null;
  }
  const [month, day, year] = value.split('/');
  const mm = parseInt(month, 10);
  const dd = parseInt(day, 10);
  const yyyy = parseInt(year, 10);
  if (isNaN(mm) || isNaN(dd) || isNaN(yyyy)) {
    return null;
  }
  const date = new Date(yyyy, mm - 1, dd);
  if (
    date.getFullYear() !== yyyy ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return null;
  }
  return date;
};
const validExpireDate = (value: string): boolean => {
  const parsed = parseMMDDYYYY(value);
  if (!parsed) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return parsed >= today;
};
@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
        isBLSProvider: Boolean,
    },
    components: {
            ModelSelect,
    },
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            licenceNumber: '',
            licenceState: '',
            birthDate: '',
            timezone: '',
            locationId: '',
            branchName: '',
            expireDate: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
            licenceStates: ProfileFormData.licenceStates,
            options: [],
            locationOptions: [],
            NREMT_RegistryNumber: '',
        };
    },
    directives: {
        dateFormat: {
            bind(el) {
                el.addEventListener('input', (e: any) => {
                    if (e && e.target && e.target) {
                        const input = e.target;
                        const selectionStart = input.selectionStart;
                        let value = input.value.replace(/\D/g, '');
                        if (value.length > 2) {
                        value = value.substring(0, 2) + '/' + value.substring(2);
                        }
                        if (value.length > 5) {
                        value = value.substring(0, 5) + '/' + value.substring(5, 9);
                        }
                        input.value = value;
                        let newPosition = selectionStart;
                        if (selectionStart === 3 || selectionStart === 6) {
                        newPosition += 1;
                        }
                        input.setSelectionRange(newPosition, newPosition);
                    }
                });
            },
        },
    },
    validations() {
        const validations = {
            fullName: {
                required,
                regex: (fullName: any) => /^[a-zA-Z0-9 ]+$/.test(fullName),
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
            email: {
                email,
                required,
            },
            licenceNumber: {
                required,
            },
            licenceState: {
                required,
            },
            birthDate: {
                required,
            },
            timezone: {},
            expireDate: {
                required,
            },
            address: {
                fullAddress: {
                    required,
                },
                locality: {},
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
            NREMT_RegistryNumber: {
                required,
            },
            expireDateFormatted: {
                required,
                mmddyyyyFormat,
                validExpireDate,
            },
            birthDateFormatted: {
                required,
                mmddyyyyFormat,
                validBirthDate,
            },
        };
        if (!this.$props.isBLSProvider) {
            delete validations.NREMT_RegistryNumber;
        }
        return validations;
    },
})

export default class AddDriverModal extends Vue {
    private locationGoogleAddress: any;
    private show = true;
    private addDriverRequest: AddDriverRequest | any;
    private documents: Document[] = [];
    private locations: TransporterLoc[] | undefined = [];
    private maxDate = new Date();
    private TimeZones = TimeZones;
    private isInvalidValidTime = false;
    private isLastMinuteRequest = false;
    private supportedFormats = [
        'image/png',
        'image/jpeg',
        'application/pdf',
    ];
    private expireDateFormatted = '';
    private birthDateFormatted: string = '';
    public mounted() {
        this.$data.options = [];
        this.getLocation();
        this.getGoogleAddress();

        this.maxDate.setFullYear(this.maxDate.getFullYear() - 23);
        this.$data.licenceStates.forEach((licenceState: any) => {
                const option = {
                    value: licenceState.name,
                    text: licenceState.name,
                };
                this.$data.options.push(option);
            });

    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('driverAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }


    /**
     * @author <shraddha.K>
     * @description - add new driver
     * @param req {Request} - calls add driver API
     * @param res {Response} - Express Response - success result
     * @returns success massage
     * @throws InvalidRequestException if driver already exists
     */
    private async addDriver() {
        const promises: Array<Promise<ApiResponse<UploadFileResponse>>> = [];
        const indexes: number[] = [];
        let index = 0;
        this.documents.forEach((document) => {
            if (document.file) {
                indexes.push(index);
                promises.push(ObjectFactory.getFileService()
                    .uploadFile(document.file, this.$store.state.serverUrl));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                let indexTemp = 0;
                uploadDocumentResponses.forEach((uploadDocumentResponse) => {
                    const documentIndex = indexes[indexTemp];
                    const document = this.documents[documentIndex];
                    delete document.file;
                    if (uploadDocumentResponse.data) {
                        document.resourceId = uploadDocumentResponse.data.fileName;
                    }
                    indexTemp++;
                });
                this.callAddDriverApi();
            });
        } else {
            this.callAddDriverApi();
        }
    }

    private async callAddDriverApi() {
        let allDocumentUploaded = true;
        this.documents.forEach((element) => {
            if (!element.resourceId) {
                allDocumentUploaded = false;
            }
        });
        if (allDocumentUploaded) {
            const iHttpService = ObjectFactory.getHttpService();
            const addDriverRequest: AddDriverRequest = {
              fullName: this.$data.fullName,
              email: this.$data.email,
              phone: this.$data.phone,
              birthDate: this.$data.birthDate,
              expireYear: this.$data.expireDate,
              licenceNo: this.$data.licenceNumber,
              licenceState: this.$data.licenceState,
              address: this.$data.address,
              documents: this.documents,
              timezone: this.$data.timezone,
              branchName: this.$data.branchName,
              locationId: this.$data.locationId,
              NREMT_RegistryNumber: this.$data.NREMT_RegistryNumber ?  this.$data.NREMT_RegistryNumber : '',
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/add`,
                data: addDriverRequest,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<Driver>(apiRequest);
            if (response.success) {
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_ADD_DRIVER'),
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.$emit('success');
                this.close();
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async handleDocumentSelect(file: any, filename: string, description?: string, refId?: string) {
        const fileName = file.target.files[0].name.toLowerCase();
        if (fileName.endsWith('.pdf') || fileName.endsWith('.png') ||
            fileName.endsWith('.jpeg') || fileName.endsWith('.jpg')) {
            const formData = new FormData();
            formData.append('file', file.target.files[0]);
            this.documents.push({
                description,
                file: formData,
                name: filename,
                resourceId: '',
                filename: file.target.files[0].name,
            });
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            if (refId) {
                const element = this.$refs[refId] as any;
                element.reset();
            }
        }
    }

    private close() {
        if (this.$route.path === `${MedTransGoConstants.URL_SETTING}/${MedTransGoConstants.URL_ADD_DRIVER}`) {
            this.$router.push({
                name: MedTransGoConstants.VIEW_SETTING_NAME,
            });
        } else {
            this.$emit('close');
        }
    }

    private async getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
        if (response.success && response.data) {
                this.$data.locationOptions = [];
                this.locations = response.data as any;
                response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.branchName,
                };
                this.$data.locationOptions.push(option);
                });
            } else {
                CommonUtils.showError(response);
            }
    }
     private getTimezoneRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            const appointmentTimestamp =
            DateUtils.convertToUTCInMillis(element.transporterProfile.appointmentDate + ' ' +
            element.transporterProfile.appointmentTime, element.appointment.timezone);
            const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
            DateUtils.FORMAT_DATETIME_AM_PM, element.appointment.timezone);
            element.transporterProfile.appointmentDate = appointmentTime;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
            element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
        });
        this.addDriverRequest.data = result;
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private formatToMMDDYYYY(date: Date): string {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    }

    private onExpiryInput() {
        this.$v.expireDateFormatted.$touch();
        const parsed = this.parseMMDDYYYY(this.expireDateFormatted);
        if (parsed) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (parsed >= today) {
                this.$data.expireDate = `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
                this.expireDateFormatted = this.$data.expireDate;
            } else {
                this.$data.expireDate = '';
            }
        } else {
            this.$data.expireDate = '';
        }
    }


    private parseMMDDYYYY(str: string): Date | null {
        const [mm, dd, yyyy] = str.split('/').map(Number);
        if (!mm || !dd || !yyyy) {
            return null;
        }
        if (mm < 1 || mm > 12 || dd < 1 || dd > 31) {
            return null;
        }
        const date = new Date(yyyy, mm - 1, dd);
        if (date.getMonth() !== mm - 1 || date.getDate() !== dd || date.getFullYear() !== yyyy) {
            return null;
        }
        return date;
    }

    private onExpireDateSelect(ctx: any) {
        if (ctx.selectedDate) {
            const date = new Date(ctx.selectedDate);
            this.expireDateFormatted = this.formatToMMDDYYYY(date);
        }
    }

    private onBirthDateSelect(ctx: any) {
        if (ctx.selectedDate) {
            const date = new Date(ctx.selectedDate);
            this.birthDateFormatted = this.formatToMMDDYYYY(date);
        }
    }

    private onBirthInput() {
        this.$v.birthDateFormatted.$touch();
        const parsed = this.parseMMDDYYYY(this.birthDateFormatted);
        if (parsed) {
            const ageLimitDate = new Date();
            ageLimitDate.setFullYear(ageLimitDate.getFullYear() - 23);
            ageLimitDate.setHours(0, 0, 0, 0);
            if (parsed <= ageLimitDate) {
                this.$data.birthDate = `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
                this.birthDateFormatted = this.$data.birthDate;
            } else {
                this.$data.birthDate = '';
            }
        } else {
            this.$data.birthDate = '';
        }
    }

}
